// src/hooks/useHandleCardsAndReviewBook

import { useEffect } from 'react'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const useHandleCardsAndReviewBook = (cards, mounted, setMounted, setShowReviewBook) => {
  useEffect(() => {
    if (Array.isArray(cards) && mounted) {
      setShowReviewBook(true)
    } else if (!mounted) {
      setMounted(true)
    }
  }, [cards, mounted, setMounted, setShowReviewBook])
}
